/* Ovena home-lux: homepage-only interaction layer.
   Pairs with assets/ovena-home-lux.css (loaded by sections/ovena-home-hero.liquid).
   Everything is progressive enhancement — if this file never runs, the page
   renders complete and static. Reveal work claims elements ahead of the
   sitewide ovena-mlux.js pass (via data-ov-io) so nothing animates twice. */
(function(){
  'use strict';
  var d=document, w=window;
  var REDUCED=false, FINE=false;
  try{REDUCED=matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(e){}
  try{FINE=matchMedia('(hover: hover) and (pointer: fine)').matches;}catch(e){}
  function onScroll(fn){
    var queued=false;
    addEventListener('scroll',function(){
      if(queued)return;queued=true;
      requestAnimationFrame(function(){queued=false;fn();});
    },{passive:true});
    fn();
  }

  /* ---- reading progress bar ---- */
  function initProgress(){
    if(d.querySelector('.ovlx-progress'))return;
    var bar=d.createElement('div');
    bar.className='ovlx-progress';bar.setAttribute('aria-hidden','true');
    d.body.appendChild(bar);
    onScroll(function(){
      var h=d.documentElement,max=h.scrollHeight-innerHeight;
      var p=max>0?Math.min(1,Math.max(0,(w.scrollY||h.scrollTop||0)/max)):0;
      bar.style.setProperty('--sp',p.toFixed(4));
    });
  }

  /* ---- back to top ---- */
  function initTop(){
    if(d.querySelector('.ovlx-top'))return;
    var btn=d.createElement('button');
    btn.type='button';btn.className='ovlx-top';btn.setAttribute('aria-label','Back to top');
    btn.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    d.body.appendChild(btn);
    btn.addEventListener('click',function(){
      try{w.scrollTo({top:0,behavior:REDUCED?'auto':'smooth'});}catch(e){w.scrollTo(0,0);}
    });
    onScroll(function(){
      btn.classList.toggle('ovlx-top--on',(w.scrollY||0)>900);
    });
  }

  /* ---- hero: pointer glow + scroll parallax + cue state ---- */
  function initHero(){
    var hero=d.querySelector('.ovx-hero.ov-hero-new');
    if(!hero)return;
    if(FINE&&!REDUCED&&!hero.querySelector('.ovlx-glow')){
      var glow=d.createElement('div');
      glow.className='ovlx-glow';glow.setAttribute('aria-hidden','true');
      hero.appendChild(glow);
      var gx=24,gy=44,tx=24,ty=44,running=false;
      function step(){
        gx+=(tx-gx)*.09;gy+=(ty-gy)*.09;
        glow.style.setProperty('--gx',gx.toFixed(2)+'%');
        glow.style.setProperty('--gy',gy.toFixed(2)+'%');
        if(Math.abs(tx-gx)>.2||Math.abs(ty-gy)>.2){requestAnimationFrame(step);}
        else{running=false;}
      }
      function aim(x,y){
        var r=hero.getBoundingClientRect();
        tx=Math.max(0,Math.min(100,(x-r.left)/r.width*100));
        ty=Math.max(0,Math.min(100,(y-r.top)/r.height*100));
        if(!running){running=true;requestAnimationFrame(step);}
      }
      hero.addEventListener('pointermove',function(e){aim(e.clientX,e.clientY);},{passive:true});
      hero.addEventListener('pointerleave',function(){
        tx=24;ty=44;
        if(!running){running=true;requestAnimationFrame(step);}
      });
    }
    onScroll(function(){
      var y=w.scrollY||0;
      d.documentElement.classList.toggle('ovlx-scrolled',y>60);
      if(REDUCED)return;
      var v=Math.min(1,y/560);
      hero.style.setProperty('--sy',(v*30).toFixed(2));
      hero.style.setProperty('--so',(1-v*.35).toFixed(3));
    });
  }

  /* ---- mobile hero: expandable full description ---- */
  function initExpand(){
    if(d.documentElement.dataset.ovlxExpand)return;
    d.documentElement.dataset.ovlxExpand='1';
    d.addEventListener('click',function(e){
      var btn=e.target&&e.target.closest&&e.target.closest('[data-ovlx-expand]');
      if(!btn)return;
      var copy=btn.closest('.ovx-hero__copy');
      if(!copy)return;
      var open=copy.classList.toggle('ovlx-open');
      btn.setAttribute('aria-expanded',open?'true':'false');
      var label=btn.querySelector('.ovlx-expand__t');
      if(label)label.textContent=open?(btn.getAttribute('data-less-label')||'Hide description')
                                     :(btn.getAttribute('data-more-label')||'Full description');
    });
  }

  /* ---- cursor spotlight vars on cards/tiles ---- */
  function initSpotlight(){
    if(!FINE||d.documentElement.dataset.ovlxSpot)return;
    d.documentElement.dataset.ovlxSpot='1';
    d.addEventListener('pointermove',function(e){
      var el=e.target&&e.target.closest&&e.target.closest('.ovh-card,.ovh-tile,.ovh-dcard');
      if(!el)return;
      var r=el.getBoundingClientRect();
      el.style.setProperty('--mx',((e.clientX-r.left)/r.width*100).toFixed(2)+'%');
      el.style.setProperty('--my',((e.clientY-r.top)/r.height*100).toFixed(2)+'%');
    },{passive:true});
  }

  /* ---- staggered scroll reveals (claims elements from ovena-mlux) ---- */
  function initReveal(){
    if(REDUCED||!('IntersectionObserver' in w))return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting)return;
        io.unobserve(en.target);
        var el=en.target;
        el.classList.add('ovlx-in');
        setTimeout(function(){
          el.classList.remove('ovlx-r','ovlx-in','ovlx-r--l','ovlx-r--rt','ovlx-r--sc');
          el.style.removeProperty('--rd');
        },1900);
      });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.05});
    function claim(el,dir,delay){
      if(!el||el.dataset.ovlx)return;
      el.dataset.ovlx='1';
      el.dataset.ovIo='1';                       /* tells ovena-mlux to skip it */
      el.classList.remove('ov-io','ov-in');
      if(el.getBoundingClientRect().top<=innerHeight*0.9)return;  /* never hide near-fold content */
      el.classList.add('ovlx-r');
      if(dir)el.classList.add(dir);
      if(delay)el.style.setProperty('--rd',delay.toFixed(2)+'s');
      io.observe(el);
    }
    function idx(el){var i=0,s=el;while((s=s.previousElementSibling))i++;return i;}
    function walkClaims(claimTarget,prepareBand){
      /* product family bands: text slides in from its side, image from the other */
      [].forEach.call(d.querySelectorAll('main .ovhomefam'),function(band){
        prepareBand(band);
        var media=band.querySelector('.ovh-media'),text=null;
        [].forEach.call(band.children,function(k){if(k!==media)text=k;});
        var flip=!!(text&&(text.getAttribute('style')||'').indexOf('order:2')>-1);
        if(text)[].forEach.call(text.children,function(c,i){
          claimTarget(c,flip?'ovlx-r--rt':'ovlx-r--l',i*.09);
        });
        if(media)claimTarget(media,flip?'ovlx-r--l':'ovlx-r--rt',.12);
      });
      /* medical director: text column staggers, photo scales in */
      [].forEach.call(d.querySelectorAll('.ovmd-grid > div:first-child > *'),function(el,i){
        claimTarget(el,null,i*.09);
      });
      [].forEach.call(d.querySelectorAll('.ovmd-photo'),function(el){
        claimTarget(el,'ovlx-r--sc',.15);
      });
      /* bulk / clinical / final: whole content column staggers */
      [].forEach.call(d.querySelectorAll('[id$="__bulk"] .ovh-wrap > *,[id$="__clinical"] .ovh-wrap > *,[id$="__final"] .ovh-wrap > *'),function(el){
        claimTarget(el,null,idx(el)*.08);
      });
      /* card grids: gentle scale-up, staggered across the row */
      [].forEach.call(d.querySelectorAll('main .ovh-card,main .ovh-dcard,main .ovh-tile'),function(el){
        claimTarget(el,'ovlx-r--sc',Math.min(idx(el)*.07,.42));
      });
      /* any remaining section headings */
      [].forEach.call(d.querySelectorAll('main .ovh-eyebrow,main .ovh-h2,main .ovh-sub,main .ovh-bulk-h,main .ovh-bulk-p,main .ovh-final-h'),function(el){
        claimTarget(el);
      });
    }
    function prepareBand(band){
      band.dataset.ovIo='1';band.classList.remove('ov-io','ov-in');
    }
    function tag(){
      var jobs=[],bands=[],seen=new WeakSet();
      walkClaims(function(el,dir,delay){
        if(!el||el.dataset.ovlx||seen.has(el))return;
        seen.add(el);jobs.push({el:el,dir:dir,delay:delay});
      },function(band){bands.push(band);});
      var active=new Set(jobs.map(function(job){return job.el;}));
      function hasActiveAncestor(el){
        for(var parent=el.parentElement;parent;parent=parent.parentElement){
          if(active.has(parent))return true;
        }
        return false;
      }
      /* Nested targets can move each other; preserve their original claim order.
         Custom elements can have synchronous attribute callbacks. */
      if(jobs.some(function(job){
        return hasActiveAncestor(job.el)||job.el.tagName.indexOf('-')!==-1;
      })||bands.some(hasActiveAncestor)){
        walkClaims(claim,prepareBand);return;
      }
      /* Independent targets use the same normalized bounds without alternating
         reveal writes and geometry reads. All phases stay synchronous. */
      bands.forEach(prepareBand);
      jobs.forEach(function(job){
        var el=job.el;
        el.dataset.ovlx='1';el.dataset.ovIo='1';
        el.classList.remove('ov-io','ov-in');
      });
      var below=jobs.map(function(job){
        return !(job.el.getBoundingClientRect().top<=innerHeight*0.9);
      });
      jobs.forEach(function(job,i){
        if(!below[i])return;
        var el=job.el;
        el.classList.add('ovlx-r');
        if(job.dir)el.classList.add(job.dir);
        if(job.delay)el.style.setProperty('--rd',job.delay.toFixed(2)+'s');
        io.observe(el);
      });
    }
    tag();
    setTimeout(tag,600);
    /* hard fallback: nothing may stay hidden if the observer never fires */
    function revealAll(){
      [].forEach.call(d.querySelectorAll('.ovlx-r'),function(el){el.classList.add('ovlx-in');});
    }
    setTimeout(revealAll,8000);
    addEventListener('beforeprint',revealAll);
  }

  function init(){
    initProgress();initTop();initHero();initExpand();initSpotlight();initReveal();
  }
  if(d.readyState!=='loading')init();
  else d.addEventListener('DOMContentLoaded',init);
  d.addEventListener('shopify:section:load',init);
})();
